import { useEffect } from "react";

// Physical-keyboard support for the on-screen numeric keypad (this is a browser register, so a real
// keyboard should work too). Maps 0-9 → digit, Backspace → "DEL", Escape/Delete → "C" (clear),
// Enter → onEnter(). Keystrokes are ignored while a real <input>/<textarea>/contentEditable is
// focused, so typing in search boxes and amount fields is never hijacked. Gate with `enabled` so
// only one keypad surface (home pad OR the open modal) receives keys at a time.
export function useNumericKeys(onKey, { enabled = true, onEnter } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const handler = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const el = document.activeElement;
      const tag = el && el.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || (el && el.isContentEditable)) return;
      if (/^[0-9]$/.test(e.key)) {
        onKey(e.key);
        e.preventDefault();
      } else if (e.key === "Backspace") {
        onKey("DEL");
        e.preventDefault();
      } else if (e.key === "Escape" || e.key === "Delete") {
        onKey("C");
        e.preventDefault();
      } else if (e.key === "Enter" && onEnter) {
        onEnter();
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onKey, enabled, onEnter]);
}
